import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isProductOneOf } from './is-product-one-of';

/**
 * Context-based eligibility check for the align edition button ads experiment.
 * Note: This does not check the experiment cohort — that is handled in useButtonContent.
 */
export function isEligibleForAlignEditionButtonAds(context: EditionAwarenessContextType): boolean {
	const { product, edition, isInPredunning, isInTrial } = context;

	return (
		Boolean(edition === 'free' || isInTrial || isInPredunning) &&
		isProductOneOf(product, ['jira', 'confluence', 'jira-product-discovery'])
	);
}
